const AquaButton = ({ onClick, type = "button", text, className, height, width, disabled = false }) => {
  return (
    <div className="flex justify-end">
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={`bg-aqua text-white rounded-[10px] w-full
        ${className}
        ${width ? width : 'sm:w-24'}
        ${height ? height : 'h-9'}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90'}
        `}
      >
        {text ? text : 'ارسال'}
      </button>
    </div>
  );
};

export default AquaButton;
